import styled, { css } from "styled-components"
import { CheckBox } from "../Checkbox"

const Layout = styled.div<{ checked: boolean }>`
  height: 48px;
  padding: 12px;
  cursor: pointer;

  box-sizing: border-box;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border-radius: 4px;

  background: ${(props) => props.theme.colors.primary99};
  color: ${(props) => props.theme.colors.primary10};

  &:hover {
    color: ${(props) => props.theme.colors.primary40};

    .--checkbox-box {
      border: 2px solid ${(props) => props.theme.colors.primary40};
    }
  }

  ${(props) =>
    props.checked &&
    css`
      background: ${props.theme.colors.primary95};
      box-shadow: ${props.theme.shadow.elevation1};
    `}
`

export interface RadioCheckProps {
  checked: boolean
  onChange: (value: boolean) => void
}

const Content = styled.span``

const RadioCheck: React.CFC<RadioCheckProps> = ({
  checked,
  onChange,
  children,
}) => {
  return (
    <Layout checked={checked} onClick={() => onChange(!checked)}>
      <Content>{children}</Content>
      <CheckBox
        checked={checked}
        onChange={onChange}
        checkedIconProps={{ color: "white", type: "solid" }}
        boxSize="18px"
        boxBorderRadius="4px"
      />
    </Layout>
  )
}

export default RadioCheck
